import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal bg_grey d-flex justify-content-between align-items-center flex-column" }
const _hoisted_2 = { class: "page_padding text-center" }
const _hoisted_3 = { class: "page_padding w-100" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "optionsContainer" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "white fs_18 me-2" }, "it-IT", -1)
const _hoisted_14 = { class: "d-flex align-items-center ms-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "white fs_18 me-2" }, "en-US", -1)
const _hoisted_16 = { class: "page_padding d-flex w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.localModel.identifier)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            type: "h3",
            class: "white text-uppercase text-center fw_700",
            localizedKey: "backoffice_ModificaUtenza",
            text: "Modifica Utenza"
          }))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            type: "h3",
            class: "white text-uppercase text-center fw_700",
            localizedKey: "backoffice_NuovaUtenza",
            text: "Nuova Utenza"
          }))
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_form_field, {
            type: "email",
            modelValue: _ctx.localModel.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localModel.email = $event)),
            placeholderKey: "backoffice_Email",
            placeholderValue: "Email",
            labelKey: "backoffice_Email",
            labelValue: "Email"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_form_field, {
            type: "password",
            modelValue: _ctx.localModel.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localModel.password = $event)),
            placeholderKey: "backoffice_Password",
            placeholderValue: "Password",
            labelKey: "backoffice_Password",
            labelValue: "Password"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_form_field, {
            type: "text",
            modelValue: _ctx.localModel.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.localModel.name = $event)),
            placeholderKey: "backoffice_Nome",
            placeholderValue: "Nome",
            labelKey: "backoffice_Nome",
            labelValue: "Nome"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_localized_text, {
              class: "input_title",
              localizedKey: "backoffice_Lingua",
              text: "Lingua"
            }),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", {
                  class: ["sameAsOption", { 'selected' : _ctx.localModel.preferredCulture == 'it-IT'}],
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.localModel.preferredCulture = 'it-IT'))
                }, null, 2)
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", {
                  class: ["sameAsOption", { 'selected' : _ctx.localModel.preferredCulture == 'en-US'}],
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.localModel.preferredCulture = 'en-US'))
                }, null, 2)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("button", {
        class: "secondaryButton w-50 me-1",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "backoffice_Annulla",
          text: "Annulla"
        })
      ]),
      _createVNode("button", {
        class: "primaryButton w-50 ms-1",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "backoffice_Salva",
          text: "Salva"
        })
      ])
    ])
  ]))
}